import { render, staticRenderFns } from "./DonationSelect.vue?vue&type=template&id=74efcc98&scoped=true"
import script from "./DonationSelect.vue?vue&type=script&lang=js"
export * from "./DonationSelect.vue?vue&type=script&lang=js"
import style0 from "./DonationSelect.vue?vue&type=style&index=0&id=74efcc98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efcc98",
  null
  
)

export default component.exports